module.exports = {
      id: "tag-usage",
      viewBox: "0 0 30.383 24.21",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#tag",
      toString: function () {
        return this.url;
      }
    }